const ProductGrid = ({
  products,
  selectedWip,
  setSelectedWip,
  setHour,
  setMinute,
  setCategoryId,
}) => {
  return (
    <div
      style={{
        maxHeight: "50vh",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "8px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        backgroundColor: "#fafafa",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "8px",
        }}
      >
        {[...products]
          .sort((a, b) =>
            a.name.localeCompare(b.name, "id", {
              sensitivity: "base",
            }),
          )
          .map((product) => {
            const selected = selectedWip === product.name;

            return (
              <button
                key={product.uuid}
                type="button"
                className="button"
                style={{
                  minHeight: "65px",
                  height: "65px",
                  padding: "6px",
                  borderRadius: "12px",
                  fontSize: "11px",
                  fontWeight: "700",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  lineHeight: "1.2",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all .15s ease",
                  backgroundColor: selected ? "#B71C1C" : "#E53935",
                  color: "#fff",
                  border: selected ? "2px solid #FFD54F" : "2px solid #C62828",
                  boxShadow: selected
                    ? "0 6px 12px rgba(0,0,0,.45)"
                    : "0 4px 8px rgba(0,0,0,.35)",
                  transform: selected ? "translateY(-2px)" : "translateY(0)",
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.transform = "translateY(2px)";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,.6)";
                }}
                onMouseUp={(e) => {
                  e.currentTarget.style.transform = selected
                    ? "translateY(-2px)"
                    : "translateY(0)";
                  e.currentTarget.style.boxShadow = selected
                    ? "0 6px 12px rgba(0,0,0,.45)"
                    : "0 4px 8px rgba(0,0,0,.35)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = selected
                    ? "translateY(-2px)"
                    : "translateY(0)";
                  e.currentTarget.style.boxShadow = selected
                    ? "0 6px 12px rgba(0,0,0,.45)"
                    : "0 4px 8px rgba(0,0,0,.35)";
                }}
                onClick={() => {
                  setSelectedWip(product.name);
                  setHour(product.shelflifeInHour || 0);
                  setMinute(product.shelflifeInMinute || 0);
                  setCategoryId(product.category?.uuid || "");
                }}
              >
                {product.name}
              </button>
            );
          })}
      </div>
    </div>
  );
};

export default ProductGrid;
